function gameFrame() {
    const buttonActivate = document.querySelector('.game_activate_js')
    if(buttonActivate) {
        buttonActivate.addEventListener('click', () => {
            const iframe = buttonActivate.dataset.iframe
            const gameArea = document.querySelector('.banner_game_wrapper')
            const strHtml =   `<iframe class="game" 
                                src="${iframe}" 
                                scrolling="no" 
                                frameborder="0" 
                                style="overflow: hidden; border: 0px; width: 100%; height: 600px;">
                                </iframe>`
            gameArea.innerHTML = strHtml
        })
    }
}
export default gameFrame